module.exports = __webpack_public_path__ + "static/media/Badge_Oncologie.f17940d9.png";